"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCanteen = function SvgCanteen(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.981 6.037v7.872",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#4D4D4D",
    cx: 10,
    cy: 14,
    rx: 3,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 8.5h2v-7a1 1 0 1 0-2 0v7z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4D4D4D",
    y: 8,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 20 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 8.5h2v-7a1 1 0 1 0-2 0v7z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4D4D4D",
    y: 8,
    width: 5,
    height: 2,
    rx: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#4D4D4D",
    cx: 10,
    cy: 4.5,
    rx: 6,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.465 9v6m11.038-6v6m3.954-6v6M.5 9v6",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCanteen);
var _default = exports["default"] = Memo;